/* eslint-disable max-len */

export const PERCENTAGE = 'PERCENTAGE';
export const INCLUDED_TARGETS = 'INCLUDED_TARGETS';
export const EXCLUDED_TARGETS = 'EXCLUDED_TARGETS';
export const VARIATION_NAME = 'VARIATION_NAME';
export const VARIATION_STYLE = 'VARIATION_STYLE';
export const TEST_NAME = 'TEST_NAME';
export const START_DATE_TIME = 'START_DATE_TIME';
export const END_DATE_TIME = 'END_DATE_TIME';
export const ELEMENT = 'script';
export const TYPE = 'text/javascript';
export const VARIATIONS = 'VARIATIONS';

export const CONFIG_PATH = '/media/matomo/matomo.json';

export const MATOMO_VARIABLES = [PERCENTAGE, INCLUDED_TARGETS, EXCLUDED_TARGETS, VARIATION_NAME, START_DATE_TIME, END_DATE_TIME, VARIATIONS, TEST_NAME];

export const MATOMO = 'matomo';

export const ORIGINAL_VARIATION = 'original';

// Event Configs
export const EVENT_SEARCH = 'eventSearch';
export const SEARCH = 'search';
export const SEARCH_CATEGORY = 'site search';
export const RESULTS_LOADED = 'Results loaded';
export const NO_RESULTS_FOUND = 'No Results Found';
export const MY_WISHLIST = 'my-wishlist';
export const WISHLIST = 'wishlist';
export const GROUPED = 'grouped';
export const HOMEPAGE = 'homepage';
export const LOGIN = 'Logged in';
export const LOGOUT = 'Logged out';
export const NOT_APPLICABLE = 'N/A';
export const CATEGORY_PRODUCT_LIST = 'CategoryProductList';
export const PRODUCT_LIST_WIDGET = 'ProductListWidget';
export const CATEOGRY_LIMIT = 5;
export const NOT_FOUND = 'notFound';
export const CHECKOUT = 'checkout';
export const ZERO = 0;
export const ONE = 1;
export const ROOT = '/';

export const PAGE_TYPE_HOME = 'Home';
export const PAGE_TYPE_CATEGORY = 'Category';
export const PAGE_TYPE_PDP = 'Product';
export const PAGE_TYPE_CART = 'Cart';
export const PAGE_TYPE_CHECKOUT_SUCCESS = 'Purchase';
export const PAGE_TYPE_SEARCH = 'searchresults';
export const PAGE_TYPE_CHECKOUT = 'Cart';
